<ngx-ui-loader></ngx-ui-loader>
<section style="padding-top: 50px;">
    <div class="container" id="click-Login" style="display: block;">
        <header style="margin-bottom: 20px;">
            <h2 class="topic-title">{{language.cs_title}}</h2>
            <span *ngIf="requestOTP" class="desc">
                {{getOTPTitle()}}
            </span>
            <span *ngIf="showLogin" class="desc">
                {{language.ed_login}}
            </span>
        </header>
        <div class="form--item">
            <div class="row" *ngIf="showLogin">
                <div class="input col-sm-12 col-md-5 col-lg-4">
                    <div class="input--container">
                        <input placeholder="{{language.cs_pid}}" [(ngModel)]="personalID" required type="text"
                            name="personalID" class="form-control" style="font-size: 14px;"/>
                    </div>
                    <div *ngIf="pidReq" class="error-message">{{loginError}}</div>
                </div>
                <div class="col-sm-12 col-md-2 col-lg-2">
                    <app-button class="download-form" text="{{language.cs_login}}" (click)="checkLogin()">
                    </app-button>
                </div>
            </div>
            <div class="row" *ngIf="requestOTP">
                <div class="input col-sm-12 col-md-5 col-lg-4">
                    <div class="input--container">
                        <input placeholder="{{language.cs_otp}}" [(ngModel)]="inputOTP" required type="text"
                            name="inputOTP" class="form-control" />
                    </div>
                    <div *ngIf="otpReq" class="error-message">{{otpError}}</div>
                </div>
                <div class="col-sm-12 col-md-2 col-lg-2">
                    <app-button class="download-form" text="{{language.cs_login}}" (click)="checkOTP()">
                    </app-button>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <app-button class="download-form" text="{{language.cs_request_otp}}" (click)="checkLogin()">
                    </app-button>
                </div>
            </div>
        </div>
    </div>



    <div class="tab-content mt-3" id="client-report-Login-On" style="display: none;">
        <header class="text-center" style="padding-bottom: 30px; margin-top: -20px;">
            <h2 class="header-title">{{language.cs_title}}</h2>
            <!-- <p *ngIf="isOne" >กรุณากรอกข้อมูลเพื่อจัดการความยินยอม และขอใช้สิทธิของเจ้าของข้อมูลส่วนบุคคล (ลูกค้าปัจจุบันเท่านั้น)</p> -->
        </header>

        <div class="container mb-5">
            <!-- *ngIf="loginSeccess" -->
            <div class="accordion" id="accordionExample">
                <div height="40" class="card mb-3 border-bottom">
                    <div class="row p-3 align-items-center">
                        <div class="col-md-6 col-lg-6">
                            <span class="ml-2" style="font-size: 17px;">{{language.ed_customer}}: </span>
                            <span class="ml-2" style="font-size: 19px;">{{customer_title_name}}{{customer_Name}}</span>
                        </div>

                        <div class="text-right col-md-6 col-lg-6">
                            <span class="text-center mr-2"><a (click)="clickLogout()" data-toggle="collapse"
                                data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive" style="color: #395E77;cursor: pointer;">{{language.ed_logout}}</a></span>
                        </div >
                    </div>
                    <div class="row p-3 align-items-center">
                        <!-- <div class="text-left mt-1 col-md-6 col-lg-9">
                            <button *ngIf="isOne" class="btn text-center mr-2 btn-warning btn-md mr-2" style="align-self: flex-end; margin-bottom: 10px;"
                                (click)="openDSAR()">การขอใช้สิทธิ์เจ้าของข้อมูลส่วนบุคคล</button>
                            <button *ngIf="isOne" class="btn text-center mr-2 btn-warning btn-md mr-2" style="align-self: flex-end; margin-bottom: 10px;"
                                (click)="openDSAR()">การขอใช้สิทธิ์เจ้าของข้อมูลส่วนบุคคล</button>
                            <button *ngIf="isOne" class="btn text-center mr-2 btn-warning btn-md" style="align-self: flex-end; margin-bottom: 10px;"
                                (click)="openConsent()">แก้ไขคำยินยอม</button>
                        </div> -->

                        <div class="text-left mt-1 col-6 col-sm-6 col-md-12 col-lg-12">
                            <button *ngIf="isOne" class="btn text-center mr-2 btn-warning btn-md" style="align-self: flex-end; margin-bottom: 10px;"
                                (click)="openAssetProfile()">
                                {{language.cs_edoc_profile}}</button>
                            <button class="btn text-center mr-2 btn-warning btn-md mr-2" style="align-self: flex-end; margin-bottom: 10px;"
                                (click)="openTaxConsent();">{{language.cs_edoc_dropdown1}}</button>
                            <button *ngIf="isOne" class="btn text-center mr-2 btn-warning btn-md" style="align-self: flex-end; margin-bottom: 10px;"
                                (click)="openConsent()">{{language.cs_consent}}</button>
                        </div>
                    </div>
                </div>

                <div class="card mb-3 border-bottom">
                    <div class="px-0 col-12">
                        <div role="tab" class="card-header p-0" id="headingFive">
                            <h2 class="mb-0">
                                <button type="button" class="btn text-left btn-primary btn-block" data-toggle="collapse"
                                    data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive"
                                    (click)="ResetCard()">
                                    {{language.ed_edoc101}}
                                </button>
                            </h2>
                        </div>
                        <div class="p-4 collapse show" id="collapseFive" aria-labelledby="headingFive"
                            data-parent="#accordionExample">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <p>{{language.ed_edoc101_1}} <span style="color: red;">{{language.ed_edoc101_1_remark}}</span></p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="container mb-3">
                                        <div class="form-check form-check-inline"
                                            *ngFor="let item of checkBoxSelectall;index as i">
                                            <input class="form-check-input" type="checkbox" id="CheckboxAll101"
                                                [(ngModel)]="item.isChecked"
                                                (change)="selectAllTest('selectHolderNoRPT101','selectfundListRPT101','but101')">
                                            <label class="form-check-label" for="CheckboxAll101">{{item.Name}}</label>
                                        </div>
                                        <div class="form-check form-check-inline"
                                            *ngFor="let item of checkBoxList; index as i">
                                            <input class="form-check-input" type="checkbox" [id]="item.Name + '101'"
                                                [(ngModel)]="item.isChecked"
                                                (change)="selectTest('selectHolderNoRPT101','selectfundListRPT101','but101')">
                                            <label class="form-check-label"
                                                [for]="item.Name + '101'">{{item.Name}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4 col-md-5 col-lg-3" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_holderno}}</label>
                                        <select class="custom-select" placeholder="" id="selectHolderNoRPT101" disabled>
                                            <option value="HolderNoAll">{{language.ed_select_all}}</option>
                                            <option *ngFor="let item of HolderNo" [value]="item">{{item}}</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4 col-md-5 col-lg-3" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_fund_code}}</label>
                                        <select class="custom-select" placeholder="กองทุน" id="selectfundListRPT101"
                                            disabled>
                                            <option value="fundListAll">{{language.ed_select_all}}</option>
                                            <option *ngFor="let item of fundListfilter" [value]="item.FundCode">
                                                {{item.FundCode}}</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4 col-md-3 col-lg-2" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_year}}</label>
                                        <select class="custom-select" id="selectDateYearRPT101" disabled>
                                            <option *ngFor="let item of year101" [value]="item">{{item}}</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-3 col-12" style="align-self: flex-end; padding-bottom: 10px;">
                                        <button type="button" id="but101" class="btn button-custom btn-primary btn-md"
                                            (click)="downloadReportPurchase()" disabled>
                                            {{language.ed_edoc101_download}}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>                

                <div class="card mb-3 border-bottom">
                    <div class="px-0 col-12">
                        <div role="tab" class="card-header p-0" id="headingFour">
                            <h2 class="mb-0">
                                <button type="button" class="btn text-left btn-primary btn-block" data-toggle="collapse"
                                    data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour"
                                    (click)="ResetCard()">
                                    {{language.ed_edoc102}}
                                </button>
                            </h2>
                        </div>
                        <div class="p-4 collapse" id="collapseFour" aria-labelledby="headingFour"
                            data-parent="#accordionExample">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <p innerHtml="{{language.ed_edoc102_1}}"></p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="container mb-3">
                                        <div class="form-check form-check-inline"
                                            *ngFor="let item of checkBoxSelectall;index as i">
                                            <input class="form-check-input" type="checkbox" id="CheckboxAll102"
                                                [(ngModel)]="item.isChecked"
                                                (change)="selectAllTest('selectHolderNoRPT102','selectfundListRPT102','but102')">
                                            <label class="form-check-label" for="CheckboxAll102"
                                                (click)="selectAllTest('selectHolderNoRPT102','selectfundListRPT102','but102')">{{item.Name}}</label>
                                        </div>
                                        <div class="form-check form-check-inline"
                                            *ngFor="let item of checkBoxList; index as i">
                                            <input class="form-check-input" type="checkbox" [id]="item.Name + '102'"
                                                [(ngModel)]="item.isChecked"
                                                (change)="selectTest('selectHolderNoRPT102','selectfundListRPT102','but102')">
                                            <label class="form-check-label"
                                                [for]="item.Name + '102'">{{item.Name}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div></div>
                                    <div class="col-sm-4 col-md-5 col-lg-3" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_holderno}}</label>
                                        <select class="custom-select" placeholder="" id="selectHolderNoRPT102" disabled>
                                            <option value="HolderNoAll">{{language.ed_select_all}}</option>
                                            <option *ngFor="let item of HolderNo" [value]="item">{{item}}</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4 col-md-5 col-lg-3" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_fund_code}}</label>
                                        <select class="custom-select" placeholder="กองทุน" id="selectfundListRPT102"
                                            disabled>
                                            <option value="fundListAll">{{language.ed_select_all}}</option>
                                            <option *ngFor="let item of fundListfilter" [value]="item.FundCode">
                                                {{item.FundCode}}</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-3 col-12" style="align-self: flex-end;padding-bottom: 10px;">
                                        <button type="button" id="but102" class="btn button-custom btn-primary btn-md"
                                            (click)="downloadReportRedemption()" disabled>
                                            {{language.ed_edoc102_download}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3 border-bottom">
                    <div class="px-0 col-12">
                        <header role="tab" class="card-header p-0" id="headingThree">
                            <button type="button" class="btn text-left btn-primary btn-block" data-toggle="collapse"
                                data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree"
                                (click)="ResetCard()">
                                {{language.ed_edoc103}}
                            </button>
                        </header>
                        <div class="p-4 collapse" id="collapseThree" aria-labelledby="headingThree"
                            data-parent="#accordionExample">

                            <div class="card-body">
                                <!-- <app-radio-client-report></app-radio-client-report> -->
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <p innerHtml="{{language.ed_edoc102_1}}"></p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="container mb-3">
                                        <div class="form-check form-check-inline"
                                            *ngFor="let item of checkBoxSelectall; index as i">
                                            <input class="form-check-input" type="checkbox" id="CheckboxAll103"
                                                [(ngModel)]="item.isChecked"
                                                (change)="selectAllTest('selectHolderNoRPT103','selectfundListRPT103','butTransfer')">
                                            <label class="form-check-label" for="CheckboxAll103">{{item.Name}}</label>
                                        </div>
                                        <div class="form-check form-check-inline"
                                            *ngFor="let item of checkBoxList; index as i">
                                            <input class="form-check-input" type="checkbox" [id]="item.Name"
                                                [(ngModel)]="item.isChecked"
                                                (change)="selectTest('selectHolderNoRPT103','selectfundListRPT103','butTransfer')">
                                            <label class="form-check-label" [for]="item.Name">{{item.Name}}</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-4 col-md-5 col-lg-3" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_holderno}}</label>
                                        <select class="custom-select" placeholder="" id="selectHolderNoRPT103" disabled>
                                            <option value="HolderNoAll">{{language.ed_select_all}}</option>
                                            <option *ngFor="let item of HolderNo" [value]="item">{{item}}</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4 col-md-5 col-lg-3" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_fund_code}}</label>
                                        <select class="custom-select" placeholder="กองทุน" id="selectfundListRPT103"
                                            disabled>
                                            <option value="fundListAll">{{language.ed_select_all}}</option>
                                            <option *ngFor="let item of fundListfilter" [value]="item.FundCode">
                                                {{item.FundCode}}</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-3 col-12" style="align-self: flex-end;padding-bottom: 10px;">
                                        <button type="button" id="butTransfer"
                                            class="btn button-custom btn-primary btn-md"
                                            (click)="downloadReportTransfer()" disabled>
                                            {{language.ed_edoc103_download}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3 border-bottom" >
                    <div class="px-0 col-12">
                        <header role="tab" class="card-header p-0" id="headingTwo">
                            <button type="button" class="btn text-left btn-primary btn-block" data-toggle="collapse"
                                data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo" (click)="ResetCard()">
                                {{language.ed_edoc104}}
                            </button>
                        </header>
                        <div class="p-4 collapse" id="collapseTwo" aria-labelledby="headingTwo"
                            data-parent="#accordionExample">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <p>{{language.ed_edoc104_1}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4 col-md-5 col-lg-3" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_holderno}}</label>
                                        <select class="custom-select" placeholder="เลือกเดือน" 
                                            id="selectHolderNoRPT106">
                                            <option value="HolderNoAll">{{language.ed_select_all}}</option>
                                            <option *ngFor="let item of HolderNo" [value]="item" >{{item}}</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4 col-md-5 col-lg-3" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_fund_code}}</label>
                                        <select class="custom-select" id="selectfundListRPT106">
                                            <option value="fundListAll">{{language.ed_select_all}}</option>
                                            <option *ngFor="let item of fundList" [value]="item.FundCode">
                                                {{item.FundCode}}</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-3 col-12" style="align-self: flex-end; padding-bottom: 10px;">
                                        <button type="button" class="btn button-custom btn-primary btn-md"
                                            (click)="downloadReportConfimation()">
                                            {{language.ed_edoc104_download}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3 border-bottom">
                    <div class="px-0 col-12">
                        <div role="tab" class="card-header p-0" id="headingOne">
                            <h2 class="mb-0">
                                <button type="button" class="btn text-left btn-primary btn-block" data-toggle="collapse"
                                    data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" (click)="ResetCard()">
                                    {{language.ed_edoc105}}
                                </button>
                            </h2>
                        </div>
                        <div class="p-4 collapse" id="collapseOne" aria-labelledby="headingOne"
                            data-parent="#accordionExample">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <p>{{language.ed_edoc105_1}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4 col-md-5 col-lg-3" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_holderno}}</label>
                                        <select class="custom-select" id="selectHolderNo">
                                            <option value="HolderAll">{{language.ed_select_all}}</option>
                                            <option *ngFor="let item of HolderNo" [value]="item">{{item}}</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-3" style="align-self: flex-end; padding-bottom: 10px;">
                                        <label for="balance-date">{{language.ed_month}}</label>
                                        <select class="custom-select" placeholder="เลือกเดือน" id="selectMonth">
                                            <option *ngFor="let month of monthListTH" [value]="month">{{month}}</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-3 col-12" style="align-self: flex-end; padding-bottom: 10px;">
                                        <button type="button" class="btn button-custom btn-primary btn-md"
                                            (click)="dowlondHolderReport()">
                                            {{language.ed_edoc105_download}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div id="ucModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header -nobg">
                <div class="float-left">
                    <h4 class="modal-title"><span class="text">Universal Consent</span></h4>
                </div>
            </div>
            <section class="wrapper-notice">
                <div class="modal-body">
                    <br>
                    <div class="ms-5 me-5 ps-3 pe-3 d-flex flex-column">
                        <div *ngFor="let item of consentDesc; index as i;">
                            <div *ngIf="item.Id != 'e7b0d940-65cb-45e0-944f-1e2cff05741e'"
                                class="d-flex justify-content-center mb-4">
                                <div class="form-check form-switch">
                                    <input class="form-check-input mt-3" type="checkbox" [id]="item.Id"
                                        [checked]="item.TransactionType == 'ACTIVE'" (change)="onChangeConsent(item)">
                                    <label class="form-check-label ms-5" [for]="item.Id">{{item.Name}}
                                        {{language_flag === 'th' ? item.Description : item.DescriptionEng}}</label>
                                </div>
                            </div>
                            <div style="height: 0.5rem; background-color: rgb(57, 94, 119); margin: 0.5rem 0rem 3rem;">
                            </div>
                        </div>
                    </div>
                    <br>
                </div>
            </section>

            <div class="modal-footer" style="margin: 0 auto">
                <app-button text="{{language.tax_confirm}}" size="lg" (click)="closeCovidModal()"></app-button>
            </div>

        </div>
    </div>
</div>

<div id="warningModalForClientReport" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="false">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header -nobg">
                <div class="float-left">
                    <h4 class="modal-title"><span class="text">คำเตือน</span></h4>
                </div>
            </div>
            <section class="wrapper-notice">
                <div class="modal-body" tabindex="4" style="line-height: 1.6;">
                    <p>{{language.ed_for_foreigner}}</p>
                </div>
            </section>
            <div class="modal-footer" style="margin: 0 auto">
                <app-button text="{{language.ed_pop_up}}" size="lg" (click)="userAgree()"></app-button>
            </div>
        </div>
    </div>
</div>